document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("ingredientModal");
  if (!modal) return;

  const titleEl = document.getElementById("modalTitle");
  const imgEl = document.getElementById("modalImage");
  const descEl = document.getElementById("modalDescription");
  const tagsEl = document.getElementById("modalTags");
  const closeBtn = modal.querySelector(".modal-close");

  function openFromButton(btn) {
    modal.classList.add("active");

    if (titleEl) titleEl.textContent = btn.dataset.name || "";
    if (imgEl) {
      const src = btn.dataset.image || "";
      imgEl.src = src;
      imgEl.style.display = src ? "block" : "none";
    }
    if (descEl) descEl.innerHTML = btn.dataset.description || "";

    const tags = (btn.dataset.tags || "")
      .split(",")
      .map(t => t.trim())
      .filter(Boolean);

    if (tagsEl) {
      tagsEl.innerHTML = tags.map(tag => `<span class="tag">${tag}</span>`).join("");
    }
  }

  document.querySelectorAll(".ingredients4 .ingredient-plus").forEach(btn => {
    btn.addEventListener("click", () => openFromButton(btn));
  });

  // Know More -> open first card if link is not set
  document.querySelectorAll("[data-open-first-ingredient]").forEach(btn => {
    btn.addEventListener("click", () => {
      const first = document.querySelector(".ingredients4 .ingredient-plus");
      if (first) openFromButton(first);
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener("click", () => modal.classList.remove("active"));
  }

  modal.addEventListener("click", e => {
    if (e.target === modal) modal.classList.remove("active");
  });

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") modal.classList.remove("active");
  });
});
